const swiperPalmares = {
    swiperInstance: null,
    init: () => {
        import('swiper/bundle').then(({Swiper}) => {
            let domEls = document.querySelectorAll('.js-swiper-palmares');
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach(el => {
                    swiperPalmares.swiperInstance = new Swiper(el, params);
                })
            }
        })
    }
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: false,
        spaceBetween: 48,
        slidesPerView: "auto",
        grid: {
            rows: 2
        },
        slideToClickedSlide: false,
        resizeObserver: true,
        updateOnWindowResize: true,
        a11y: true,
        mousewheel: {
            forceToAxis: true
        },
        freeMode: true,
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            // type: 'bullets',
        },
        // breakpoints: {
        //     768: {
        //         spaceBetween: 48,
        //     }
        // }
    }
}

export default swiperPalmares;